<template>
  <div>
    <div class="header">
      <div class="menu">
        <el-row>
          <el-col :span="12"
            ><div class="grid-content bg-purple">
              <img class="log" src="../content/img/hdlog1.png" /></div
          ></el-col>
          <el-col :span="10"
            ><div class="grid-content bg-purple-light home-menu">
              <div><router-link to="/">首页</router-link></div>
              <div><router-link to="/notice">会议通知</router-link></div>
              <div><router-link to="/submit">提交系统</router-link></div>
              <div><router-link to="/entrance">注册</router-link></div>
            </div></el-col
          >
          <el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
        </el-row>
      </div>
    </div>
    <div class="login" v-if="!isShowFindPwd">
      <div class="login-title">
        <!-- <span>参赛学校登录</span>  -->
        <div
          @click="change(0)"
          :class="
            0 == indexPage
              ? 'login-change cursor login-checked-color'
              : 'login-change cursor'
          "
        >
          参赛学校登录
        </div>
        <div
          @click="change(1)"
          :class="
            1 == indexPage
              ? 'login-change cursor login-checked-color'
              : 'login-change cursor'
          "
        >
          个人登录
        </div>
      </div>

      <div class="login-content">
        <div class="input" v-if="indexPage == 0">
          <el-select
            v-model="userNO"
            filterable
            placeholder="请选择学校"
            style="width: 100%; max-width: 437px"
            no-match-text="未找到匹配的数据"
          >
            <el-option
              v-for="item in options.Models"
              :key="item.SchoolNO"
              :label="item.SchoolName"
              :value="item.SchoolNO"
            >
            </el-option>

            <template #empty
              ><li class="el-select-dropdown__item select_li">
                <span>{{ dataLoading }}</span>
              </li></template
            >
          </el-select>
        </div>
        <div class="input" v-else-if="indexPage == 1">
          <el-input
            placeholder="请输入账号"
            v-model="userNO"
            @keyup.enter="submitLogin"
          ></el-input>
        </div>
        <div class="input">
          <form>
            <el-input
              placeholder="请输入密码"
              v-model="password"
              show-password
              @keyup.enter="submitLogin"
            ></el-input>
          </form>
        </div>
        <div @click="submitLogin" class="submit">
          <span>登录</span>
        </div>
        <div>
          <el-button type="text" class="find-pwd" @click="findPwd"
            >找回密码</el-button
          >
        </div>
      </div>
    </div>
    <div v-else>
      <findPwdVue @callBack="findPwdCallBack"></findPwdVue>
    </div>
  </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { login, GetCurrentUser } from '../http/login'
import { ElMessage, ElLoading } from 'element-plus'
import { _local } from '../utils/storage'
import router from '../router/index'
import { getSchoolList } from '../http/entrance'
import findPwdVue from './FindPwd.vue'
export default {
  components: {
    findPwdVue
  },
  setup() {
    let password = ref()
    let userNO = ref('')
    let code = ref('')
    let isShowFindPwd = ref(false)
    let indexPage = ref(0)
    const change = (index) => {
      userNO.value = ''
      indexPage.value = index
    }
    const findPwd = () => {
      isShowFindPwd.value = true
    }
    const findPwdCallBack = () => {
      isShowFindPwd.value = false
    }
    const submitLogin = () => {
      //登录
      if (userNO.value == null || userNO.value == '') {
        ElMessage({
          message: '请输入登录名',
          type: 'warning'
        })
        return
      }
      if (password.value == null || password.value == '') {
        ElMessage({
          message: '请输入密码',
          type: 'warning'
        })
        return
      }

      let data = {
        LoginName: userNO.value,
        LoginPassword: password.value
      }
      const loading = ElLoading.service({
        lock: true,
        text: '登录中······',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      login(data)
        .then((res) => {
          if (res.IsSuccess) {
            _local.set('token', res.Token, 60 * 60 * 1000 * 12)
            //获取当前登录用户
            GetCurrentUser().then((obj) => {
              if (obj.IsSuccess) {
                ElMessage({
                  message: '登录成功',
                  type: 'success'
                })
                loading.close()
                _local.set('user', obj.Model, 60 * 60 * 1000 * 12)
                if (obj.Model.RoleId == '1') {
                  router.push('/backIndex')
                } else {
                  router.push('/')
                }
              } else {
                ElMessage.error(obj.ErrorMessage)
                loading.close()
              }
            })
          } else {
            ElMessage.error(res.ErrorMessage)
            loading.close()
          }
        })
        .catch(() => {
          loading.close()
        })
    }
    var options = reactive({
      Models: []
    })
    let dataLoading = ref('数据加载中')
    const getList = async () => {
      await getSchoolList({})
        .then((res) => {
          if (res.IsSuccess) {
            options.Models = res.Models
            dataLoading.value = '暂无数据'
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
    getList()
    return {
      indexPage,
      change,
      password,
      userNO,
      submitLogin,
      code,
      dataLoading,
      options,
      findPwd,
      isShowFindPwd,
      findPwdCallBack
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  height: 88px;
}
.log {
  width: 265.9px;
  height: 48px;
  margin: 0 417.1px 0 0;
  padding: 0 34.2px 0 154.7px;
  background-color: var(--h-0-s-0-l-100);
  margin-top: 19px;
}
.menu {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 88px;
  -webkit-backdrop-filter: blur(32px);
  backdrop-filter: blur(32px);
  background-color: var(--h-0-s-0-l-100);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
}
.home-menu {
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    // padding:0 5% 0 5%;
    text-align: center;
    width: 150px;
    a {
      text-decoration: none;
      color: black;
      width: 40px;
    }
  }
}
#btn-login {
  text-align: center;
  width: 62px;
  //margin: 9px 0 7px 58px;
  padding: 7px 17px;
  border: solid 1px white;
  > span {
    width: 28px;
    // height: 18px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: white;
  }
}
.login {
  .login-change {
    margin-left: 40px;
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 40px;
    text-align: center;
    letter-spacing: 1.2px;
    float: left;
    width: 200px;
  }
  .login-checked-color {
    border-bottom: 4px solid #a31f34;
  }
  border: solid 1px #e4e4e4;
  background-color: var(--h-0-s-0-l-100);
  width: 502px;
  height: 330px;
  margin: 0 auto;
  margin-top: 66px;
  .code-img {
    float: right;
    width: 98px;
    height: 40px;
    border-radius: 5px;
    background-color: var(--h-0-s-0-l-100);
  }
  .login-title {
    padding: 10px 0 22px 0;
    border-bottom: 1px solid #e4e4e4;
    height: 20px;
    > span {
      margin-left: 51px;
      width: 83px;
      height: 24px;
      flex-grow: 0;
      font-family: MicrosoftYaHeiUI;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: 0.8px;
      text-align: left;
      color: #4a4a4a;
    }
  }
  .login-content {
    margin: 50px 51px 0 51px;
    .input {
      width: 396px;
      height: 44px;
      flex-grow: 0;
      margin-top: 20px;
    }
    .input-yzm {
      width: 280px;
      height: 44px;
      flex-grow: 0;
      //   display: inline;
    }
  }
  .submit {
    width: 100%;
    max-width: 437px;
    height: 44px;
    flex-grow: 0;
    margin: 20px 0 10px 0;
    background-color: #a31f34;
    text-align: center;
    line-height: 44px;
    cursor: pointer;
    > span {
      // line-height: 44px;
      height: 28px;
      flex-grow: 0;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.75;
      letter-spacing: 3.2px;
      text-align: center;
      color: white;
    }
  }
  .find-pwd {
    color: blue;
    cursor: pointer;
  }
}
.cursor {
  cursor: pointer;
}
</style>
